import { connect } from 'react-redux';
import * as authActions from 'redux-modules/auth/actions.js';
import AutoLogout from "./AutoLogout";


function mapDispatchToProps(dispatch) {
  return {
    onInActivity: () => {
      dispatch(authActions.logout());
    }
  };
}

export default connect(null, mapDispatchToProps)(AutoLogout);
